export interface TeamProxyRelations {
  userID: string;
  proxyCoachees: string[];
  proxyCoaches: string[];
}

export interface TeamProxyMapResponse {
  success: boolean;
  messageCode: string;
  proxyRelations: TeamProxyRelations[];
}

export interface GetProxy {
  getTeamProxyV2: TeamProxyMapResponse;
}

export const EmptyTeamProxyResponse: GetProxy = {
  getTeamProxyV2: {
    success: false,
    messageCode: '',
    proxyRelations: [],
  },
};
